/* Tasting flight: holds the session in the browser until submit.
 * Nothing leaves the browser unless the guest enters an email AND opts in.
 * Klaviyo calls are in submitToKlaviyo. */
(function () {
  'use strict';

  var root = document.querySelector('[data-tasting-flight]');
  if (!root) return;

  var configEl = root.querySelector('[data-tf-config]');
  var config = {};
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {}

  var STORAGE_KEY = 'sv_tasting:' + config.collectionHandle + ':v1';
  var TTL_MS = 24 * 60 * 60 * 1000;
  var MIN_TIME_MS = 3000;
  var loadedAt = Date.now();

  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-tf-card]'));
  var form = root.querySelector('[data-tf-form]');
  if (!form || !cards.length) return;

  var flightEl = root.querySelector('[data-tf-flight]');
  var emailEl = form.querySelector('[data-tf-email]');
  var optinEl = form.querySelector('[data-tf-optin]');
  var warningEl = form.querySelector('[data-tf-warning]');
  var errorEl = form.querySelector('[data-tf-error]');
  var hpEl = form.querySelector('[data-tf-hp]');
  var submitBtn = form.querySelector('[data-tf-submit]');
  var thanksEl = root.querySelector('[data-tf-thanks]');

  /* ---------- storage (falls back to memory if localStorage is blocked) ---------- */
  var memoryStore = null;
  function readStore() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return memoryStore;
    }
  }
  function writeStore(obj) {
    memoryStore = obj;
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(obj));
    } catch (e) {}
  }
  function clearStore() {
    memoryStore = null;
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  /* ---------- state ---------- */
  function uuid() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 3) | 8).toString(16);
    });
  }
  function blankWine() {
    return { rating: 0, liked: null, flavors: [], notes: '' };
  }
  function freshState() {
    var now = new Date().toISOString();
    return { session_id: uuid(), started_at: now, updated_at: now, wines: {}, email: '', opt_in: false };
  }

  var state = readStore();
  if (!state || !state.started_at || Date.now() - new Date(state.started_at).getTime() > TTL_MS) {
    state = freshState();
  }
  state.wines = state.wines || {};

  var saveTimer = null;
  function save() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      state.updated_at = new Date().toISOString();
      writeStore(state);
    }, 200);
  }
  function wineFor(card) {
    var id = card.getAttribute('data-product-id');
    if (!state.wines[id]) state.wines[id] = blankWine();
    return state.wines[id];
  }
  function isTouched(w) {
    return !!(w && (w.rating || w.liked || (w.flavors && w.flavors.length) || (w.notes && w.notes.trim())));
  }

  /* ---------- rendering a card from state ---------- */
  function renderStars(card, rating) {
    card.querySelectorAll('[data-tf-star]').forEach(function (btn) {
      var v = parseInt(btn.getAttribute('data-tf-star'), 10);
      btn.classList.toggle('is-on', v <= rating);
      btn.setAttribute('aria-checked', v === rating ? 'true' : 'false');
    });
  }
  function renderLike(card, liked) {
    card.querySelectorAll('[data-tf-like]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-tf-like') === liked ? 'true' : 'false');
    });
  }
  function findChip(card, flavor) {
    var chips = card.querySelectorAll('[data-tf-flavor]');
    for (var i = 0; i < chips.length; i++) {
      if (chips[i].getAttribute('data-tf-flavor').toLowerCase() === flavor.toLowerCase()) return chips[i];
    }
    return null;
  }
  function createChip(card, flavor) {
    var chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'tf-chip';
    chip.setAttribute('data-tf-flavor', flavor);
    chip.setAttribute('aria-pressed', 'true');
    chip.textContent = flavor;
    var more = card.querySelector('[data-tf-more]');
    more.parentNode.insertBefore(chip, more);
    return chip;
  }
  function renderCard(card) {
    var w = wineFor(card);
    renderStars(card, w.rating);
    renderLike(card, w.liked);
    (w.flavors || []).forEach(function (f) {
      var chip = findChip(card, f) || createChip(card, f);
      chip.setAttribute('aria-pressed', 'true');
    });
    if (w.notes) {
      card.querySelector('[data-tf-note]').value = w.notes;
      card.querySelector('[data-tf-note-field]').hidden = false;
      card.querySelector('[data-tf-note-toggle]').setAttribute('aria-expanded', 'true');
    }
  }

  // Drop saved wines that are no longer in the collection.
  var validIds = cards.map(function (c) {
    return c.getAttribute('data-product-id');
  });
  Object.keys(state.wines).forEach(function (id) {
    if (validIds.indexOf(id) === -1) delete state.wines[id];
  });
  cards.forEach(renderCard);
  emailEl.value = state.email || '';
  optinEl.checked = !!state.opt_in;

  /* ---------- submit panel UI ---------- */
  function validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  }
  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = !msg;
  }
  function updateSubmitUI() {
    var willSend = optinEl.checked;
    warningEl.hidden = willSend;
    submitBtn.textContent = willSend ? 'Email me my notes' : 'Finish without saving';
  }
  updateSubmitUI();

  /* ---------- interactions ---------- */
  root.addEventListener('click', function (e) {
    var card = e.target.closest('[data-tf-card]');
    if (!card) return;
    var w = wineFor(card);

    var star = e.target.closest('[data-tf-star]');
    if (star) {
      var v = parseInt(star.getAttribute('data-tf-star'), 10);
      w.rating = w.rating === v ? 0 : v;
      renderStars(card, w.rating);
      return save();
    }

    var like = e.target.closest('[data-tf-like]');
    if (like) {
      var val = like.getAttribute('data-tf-like');
      w.liked = w.liked === val ? null : val;
      renderLike(card, w.liked);
      return save();
    }

    var chip = e.target.closest('[data-tf-flavor]');
    if (chip) {
      var flavor = chip.getAttribute('data-tf-flavor');
      var on = chip.getAttribute('aria-pressed') !== 'true';
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      w.flavors = w.flavors.filter(function (f) {
        return f.toLowerCase() !== flavor.toLowerCase();
      });
      if (on) w.flavors.push(flavor);
      return save();
    }

    if (e.target.closest('[data-tf-more]')) {
      var row = card.querySelector('[data-tf-more-row]');
      var opening = row.hidden;
      row.hidden = !opening;
      card.querySelector('[data-tf-more]').setAttribute('aria-expanded', opening ? 'true' : 'false');
      if (opening) card.querySelector('[data-tf-more-input]').focus();
      return;
    }

    if (e.target.closest('[data-tf-more-add]')) {
      return addCustomFlavor(card);
    }

    if (e.target.closest('[data-tf-note-toggle]')) {
      var field = card.querySelector('[data-tf-note-field]');
      var show = field.hidden;
      field.hidden = !show;
      e.target.closest('[data-tf-note-toggle]').setAttribute('aria-expanded', show ? 'true' : 'false');
      if (show) card.querySelector('[data-tf-note]').focus();
    }
  });

  function addCustomFlavor(card) {
    var input = card.querySelector('[data-tf-more-input]');
    var text = input.value.trim().slice(0, 30);
    if (!text) return;
    var w = wineFor(card);
    var existing = findChip(card, text);
    var chip = existing || createChip(card, text);
    chip.setAttribute('aria-pressed', 'true');
    w.flavors = w.flavors.filter(function (f) {
      return f.toLowerCase() !== text.toLowerCase();
    });
    w.flavors.push(existing ? existing.getAttribute('data-tf-flavor') : text);
    input.value = '';
    input.focus();
    save();
  }

  root.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-tf-more-input]')) {
      e.preventDefault();
      addCustomFlavor(e.target.closest('[data-tf-card]'));
    }
  });

  root.addEventListener('input', function (e) {
    if (e.target.matches('[data-tf-note]')) {
      wineFor(e.target.closest('[data-tf-card]')).notes = e.target.value;
      save();
    }
  });

  emailEl.addEventListener('input', function () {
    state.email = emailEl.value;
    showError('');
    save();
  });
  optinEl.addEventListener('change', function () {
    state.opt_in = optinEl.checked;
    showError('');
    updateSubmitUI();
    save();
  });

  /* ---------- payload ---------- */
  function buildPayload(email) {
    var wines = [];
    cards.forEach(function (card) {
      var w = state.wines[card.getAttribute('data-product-id')];
      if (!isTouched(w)) return;
      var item = {
        title: card.getAttribute('data-title'),
        product_url: card.getAttribute('data-url')
      };
      var img = card.getAttribute('data-image');
      if (img) item.image_url = img.indexOf('//') === 0 ? 'https:' + img : img;
      if (w.rating) item.rating = w.rating;
      if (w.liked) item.liked = w.liked === 'like';
      if (w.flavors.length) item.flavors = w.flavors.slice();
      if (w.notes.trim()) item.notes = w.notes.trim();
      wines.push(item);
    });
    return {
      email: email,
      session_id: state.session_id,
      flight_name: config.flightName,
      collection_handle: config.collectionHandle,
      email_opt_in: true,
      consent_version: config.consentVersion,
      consent_text: config.consentText,
      submitted_at: new Date().toISOString(),
      wines: wines
    };
  }

  /* ---------- Klaviyo ----------
   * Uses Klaviyo's public Client API (safe for browsers; public key only).
   *   1) POST /client/subscriptions  subscribes the email to the list (single opt-in)
   *   2) POST /client/events         "Tasting Completed", unique_id = session id (dedupes resubmits)
   * Only called when the guest entered an email AND checked the opt-in box.
   * If the public key or list ID is blank, this runs as a dry run and sends nothing. */
  var KLAVIYO_REVISION = '2025-07-15';

  function klaviyoPost(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(config.klaviyoPublicKey), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('Klaviyo ' + path + ' failed with status ' + res.status);
      return res;
    });
  }

  function submitToKlaviyo(payload) {
    if (!config.klaviyoPublicKey || !config.klaviyoListId) {
      return new Promise(function (resolve) {
        if (window.console && console.info) console.info('[tasting-flight] dry run payload', payload);
        setTimeout(function () {
          resolve({ dryRun: true });
        }, 500);
      });
    }

    var profile = { data: { type: 'profile', attributes: { email: payload.email } } };

    var subscribeBody = {
      data: {
        type: 'subscription',
        attributes: { custom_source: 'Tasting Flight', profile: profile },
        relationships: { list: { data: { type: 'list', id: config.klaviyoListId } } }
      }
    };

    var properties = {};
    Object.keys(payload).forEach(function (k) {
      if (k !== 'email') properties[k] = payload[k];
    });

    var eventBody = {
      data: {
        type: 'event',
        attributes: {
          properties: properties,
          metric: { data: { type: 'metric', attributes: { name: 'Tasting Completed' } } },
          profile: profile,
          time: payload.submitted_at,
          unique_id: payload.session_id
        }
      }
    };

    return klaviyoPost('subscriptions', subscribeBody)
      .then(function () {
        return klaviyoPost('events', eventBody);
      })
      .then(function () {
        return { dryRun: false };
      });
  }

  /* ---------- finish ---------- */
  function showThanks(title, message, dryRun) {
    flightEl.hidden = true;
    form.hidden = true;
    root.querySelector('[data-tf-thanks-title]').textContent = title;
    root.querySelector('[data-tf-thanks-message]').textContent = message;
    root.querySelector('[data-tf-dryrun]').hidden = !dryRun;
        root.querySelector('[data-tf-dryrun]').hidden = !dryRun;
    var subtitle = root.querySelector('.tf-subtitle');
    if (subtitle) subtitle.hidden = true;
    thanksEl.hidden = false;
    thanksEl.focus();
    window.scrollTo({ top: root.getBoundingClientRect().top + window.pageYOffset - 16 });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    showError('');

    // Bot checks: pretend success, send nothing.
    if (hpEl.value || Date.now() - loadedAt < MIN_TIME_MS) {
      clearStore();
      return showThanks('Thank you', 'Thanks for tasting with us.', false);
    }

    var email = emailEl.value.trim();

    // No opt-in: store nothing, send nothing.
    if (!optinEl.checked) {
      clearStore();
      state = freshState();
      return showThanks(
        'Thanks for tasting with us',
        "Because you didn't opt in, we haven't saved or sent your tasting notes.",
        false
      );
    }

    if (!validEmail(email)) {
      showError('Please enter a valid email address so we can send your notes.');
      emailEl.focus();
      return;
    }

    var payload = buildPayload(email);
    if (!payload.wines.length) {
      showError('Add a rating, flavor, or note for at least one wine to receive your tasting notes.');
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending…';
    submitToKlaviyo(payload).then(
      function (result) {
        clearStore();
        state = freshState();
        showThanks('Thank you', 'Your tasting notes are on their way to ' + email + '.', result && result.dryRun);
      },
      function () {
        submitBtn.disabled = false;
        updateSubmitUI();
        showError("Something went wrong and your notes weren't sent. Your answers are still here, so please try again.");
      }
    );
  });

  root.querySelector('[data-tf-restart]').addEventListener('click', function () {
    clearStore();
    window.location.reload();
  });
})();